import React, { useState } from 'react'
import { useModalProvider } from '../../../Providers/ModalProvider'
import { MobergColumn, MobergRow, MobergHeader, MobergDropdown, MobergButton, MobergTheme, MobergButtonVariant } from '../../../Moberg'
import { formatDate } from '../../../Pages/Data/Visualize/DataReview/utils'

export type VisitNumberRecord = {
    date: string
    visitNumber: string
}

type VisitNumberSelectorProps = {
    onSubmit: (visitNumber: string | undefined) => void
    visitNumberRecords: VisitNumberRecord[]
}

export const VisitNumberSelector: React.FC<VisitNumberSelectorProps> = ({ onSubmit, visitNumberRecords }) => {
    const [selectedVisitNumber, setSelectedVisitNumber] = useState(visitNumberRecords[0].visitNumber)
    const { close } = useModalProvider()

    const closeAndSubmit = (value: string | undefined) => {
        close().then(() => {
            onSubmit(value)
        })
    }

    return (
        <MobergColumn gap="16px" style={{ padding: "8px 16px", minWidth: "300px", minHeight: "200px" }}>
            <MobergRow horizontalAlign="space-between"  gap="128px">
                <MobergHeader>
                    Choose the correct visit number
                </MobergHeader>
            </MobergRow>

            <div style={{ flex: 1 }}>
                <MobergDropdown 
                    selectedValue={selectedVisitNumber}
                    options={visitNumberRecords.map(({ visitNumber, date }) => ({ label: `${visitNumber} (${formatDate(new Date(date), { timeZoneName: true })})`, value: visitNumber }))}
                    onChange={visitNumber => setSelectedVisitNumber(visitNumber)}
                />
            </div>

            <MobergRow gap="8px" horizontalAlign="right">
                <MobergButton onClick={() => closeAndSubmit(undefined)} theme={MobergTheme.BLUE} variant={MobergButtonVariant.OUTLINE}>
                    Cancel
                </MobergButton>
                <MobergButton onClick={() => closeAndSubmit(selectedVisitNumber)} theme={MobergTheme.BLUE} variant={MobergButtonVariant.FILLED}>
                    OK
                </MobergButton>
            </MobergRow>
        </MobergColumn>
    )
}